import React from 'react'

import clsx from 'clsx'

import Paper from 'components/Paper'

import classes from './Card.module.scss'

/** @type {import("./types").default} */
const Card = ({ children, elevation = 1, className, ...props }) => {
  return (
    <Paper elevation={elevation} className={clsx('Card', classes.root, className)} {...props}>
      {children}
    </Paper>
  )
}

export default Card
